module.exports = __webpack_public_path__ + "img/icb-co-Inte-e@2x.2e55db05.png";